import { render, staticRenderFns } from "./InstrumentAvatar.vue?vue&type=template&id=d79fc8d2&scoped=true"
import script from "./InstrumentAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstrumentAvatar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79fc8d2",
  null
  
)

export default component.exports